import React, { useContext } from 'react';
import AuthContext from 'context/authContext';
import { useNavigate } from 'react-router-dom';
import MosqueForm from './MosqueForm';
import useUpload from 'hooks/useUpload';
import paths from 'routes/paths';
import { useCreateMosque } from 'hooks/useBeneficiaries';

function AddMosque() {
  const { organization, selectedBranchId } = useContext(AuthContext);
  const navigate = useNavigate();
  const { upload, loading: uploadLoading } = useUpload();
  const { createMosqueAsync, isCreating } = useCreateMosque();

  const submitAddMosque = async data => {
    try {
      if (data.document && typeof data.document !== 'string') {
        data.document = await upload(data.document);
      }

      const mosqueData = {
        ...data,
        organisation_id: organization.id
      };

      // Only add branch_id if it's not 'all'
      if (selectedBranchId && selectedBranchId !== 'all') {
        mosqueData.branch_id = selectedBranchId;
      }

      await createMosqueAsync(mosqueData);
      navigate(paths.mosque);
    } catch (error) {
      console.error('Error creating mosque:', error);
    }
  };

  return (
    <MosqueForm onSubmit={submitAddMosque} loading={isCreating || uploadLoading} />
  );
}

export default AddMosque;
